window.MinimumMinorAgeAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    self.minorHandlingSettingsEnabled = cacheService.cache(function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            deferred.reject("No brand id");
        } else {
            _protected.request("brands/" + brandId + "/minor_handling_settings", "GET")
                .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                }, function (err) {
                    deferred.reject(err);
                });
        }

        return deferred.promise;
    })[0];

});
